class ScaleDay {
	static get DURATION() {return 86400000;}

	static seed(bar, dateTime) {
		let i = new ScaleDay(bar);
		i.start = Date.UTC(dateTime.getFullYear(), dateTime.getUTCMonth(), dateTime.getDate());
		return i;
	}
	
	static before(bar, other) {
		let i = new ScaleDay(bar);
		i.end = other.start;
		return i;
	}

	static after(bar, other) {
		let i = new ScaleDay(bar);
		i.start = other.end;
		return i;
	}

	constructor(bar) {
		this._scale = bar._scale;
		this._start;
		this._width;

		this._elem = UI.div('scaleDay', this._text = UI.span());
		bar._dayBar.appendChild(this._elem);
		onEv(this._elem, 'mousedown touchstart', this.goto.bind(this));
	}

	dispose() {
		this._elem.remove();
	}

	goto() {
		this._scale.gotoDate = this.start + (ScaleDay.DURATION / 2);
	}
	get start() {return this._start;}
	get end() {return this._start + ScaleDay.DURATION;}

	set start(v) {
		this._start = v;
		this.initText();
	}

	set end(v) {
		this._start = v - ScaleDay.DURATION;
		this.initText();
	}
	
	initText() {
		let dt = new Date(this._start);
		this._elem.className = dt.getDay() === 6 || dt.getDay() === 0 ? 'scaleWeekendDay' : 'scaleDay';
		this._day = App.WKD[dt.getDay()];
		this._date = dt.getDate();
		this.size();
	}

	size() {
		this._width = this._scale._timeline.millisecsToPixels(ScaleDay.DURATION);
		this._elem.style.width = this._width + 'px';

		if (this._width < 35) {
			this._text.innerHTML = this._date;
		} else if (this._width < 65) {
			this._text.innerHTML = numSuffix(this._date);
		} else {
			this._text.innerHTML = this._day + ' ' + numSuffix(this._date);
		}
	}

	move() {
		let left = this._scale._timeline.timeToOffset(this._start);
		this._elem.style.left = left + 'px';

		if (0 < left) {
			this._text.style.left = '5px';
		} else if (this._text.offsetWidth - this._width + 10 < left) {
			this._text.style.left = (-left + 5) + 'px';
		} else {
			this._text.style.left = (this._width - this._text.offsetWidth - 5) + 'px';
		}
	}
}
